import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "../../../common/commonService";
import { urlConstant } from "../../../constant/urlConstant";
import { CommonPaymentComponent } from "../../../shared/common-payment/common-payment/common-payment.component";
import { MatDialog } from "@angular/material";
import Swal from "sweetalert2";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ImageShowModalComponent } from "../../../shared/image-slider/image-show-modal/image-show-modal.component";
import { Color } from "ng2-charts";
import { ChartOptions, ChartType } from "chart.js";
import { Globals } from "../../../globals";

@Component({
  selector: "app-add-proforma-invoice",
  templateUrl: "./add-proforma-invoice.component.html",
  styleUrls: ["./add-proforma-invoice.component.scss"],
})
export class AddProformaInvoiceComponent implements OnInit {
  @ViewChild("viewInvoiceModal", { static: false })
  public viewInvoiceModal: ModalDirective;
  propertyId: any;
  propertyData: any;
  currentDate: any;
  doughnutChartColors: Color[] = [
    {
      backgroundColor: [
        "#44cc44",
        "#eecc00",
        "#ee7700",
        "#92A8D1",
        "#B55A30",
        "#FDAC53",
        "#F5DF4D",
        "#0072B5",
        "#A0DAA9",
        "#E9897E",
      ],
    },
  ];
  totalInvoices: number = 0;
  totalPaidInvoices: number = 0;
  totalPendingInvoices: number = 0;

  totalAmountPaid: number = 0;
  totalDueAmount: number = 0;
  remainingAmount: number = 0;

  public doughnutChartOptions: ChartOptions = {
    responsive: true,
    legend: { display: false },
  };
  public doughnutChartAmountLabels: string[] = [
    "Paid Amounts",
    "Remaning Amounts",
  ];
  public doughnutChartAmountData: number[] = [];
  public doughnutChartInvoiceLabels: string[] = [
    "Paid Invoices",
    "Pending Invoices",
  ];
  public doughnutChartInvoiceData: number[] = [];
  public doughnutChartType: ChartType = "doughnut";
  options = { legend: { display: false } };
  invoiceList: any[] = [];
  recepintList: any[] = [];
  modalInvoice: any = {};
  userToDetail: any = {};
  userFromDetail: any = {};
  modalPaymentList: any[] = [];
  paymentFrom: any;
  paymentTo: any;
  userFromRoleId: any;
  userToRoleId: any;
  totalPaidAmount: number = 0;
  totalPendingAmount: number = 0;
  invoiceTotalNumber: any = {};
  invoiceTotalPayment: any = {};
  loginUser: any;
  invoice: any;

  constructor(
    public toasterService: ToasterService,
    public route: ActivatedRoute,
    public router: Router,
    public _CommonService: CommonService,
    public MatDialog: MatDialog
  ) {
    this.propertyId = this.route.snapshot.params.id;
    this.currentDate = new Date();
  }

  ngOnInit() {
    this.loginUser = this._CommonService.getLoggedInUser();
    this.getParamMaster();
    if (this.propertyId) {
      this.getPropertyDetails();
      this.getPropertyInvoice();
    }
  }

  getParamMaster() {
    this._CommonService
      .get<any>(
        urlConstant.PropertyStatus.getParamByType +
          "?type=" +
          "Payment Recipient"
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.recepintList = res.data.paramList;
        }
      });
  }

  getPropertyDetails() {
    this._CommonService.showLoading();
    this._CommonService
      .get<any>(
        urlConstant.Property.GetPropertyByPropertyId +
          "?propertyId=" +
          this.propertyId
      )
      .subscribe(
        (res) => {
          this._CommonService.hideLoading();
          if (res.Status === "200") {
            this.propertyData = res.data.Property;
          } else {
            this.toasterService.pop("error", "Error", res.message);
          }
        },
        (error) => {
          if (error != null) {
            this.toasterService.pop("error", "Error", error.message);
          }
          this._CommonService.hideLoading();
        }
      );
  }

  generatePerofmaInvoice() {
    let invoiceObj = {
      propertyId: this.propertyId,
      proformaInvoiceDate: new Date(this.currentDate)
        .toISOString()
        .split("T")[0],
    };
    console.log("invoiceObj", invoiceObj);
    this._CommonService.showLoading();

    this._CommonService
      .post(urlConstant.ProformaInvoice.generateProformaInvoice, invoiceObj)
      .subscribe((res: any) => {
        if (res.Status === "200") {
          console.log("res", res);
          this.invoice = res.data.ProformaInvoice;
          this.router.navigate([
            `admin/invoice-performa/performa-invoice/${this.propertyId}_inv_${res.data.ProformaInvoice.id}`,
          ]);

          this.toasterService.pop("success", "Success", res.message);
          this._CommonService.hideLoading();
        } else {
          this.toasterService.pop("error", "Error", res.message);
          this._CommonService.hideLoading();
        }
      });
  }

  // generateReceipt(invoice) {
  //   this.router.navigate([
  //     `admin/invoice-performa/performa-invoice/${this.propertyId}_rec_${invoice.id}`,
  //   ]);
  // }

  converttoInvoice(invoice: any) {
    if (!invoice || !invoice.id) {
      this.toasterService.pop("error", "Error", "Invalid invoice data");
      return;
    }
    console.log("converttoInvoice", invoice.id);

    const apiUrl = `${urlConstant.ProformaInvoice.convertToInvoice}?proformaId=${invoice.id}`;

    this._CommonService.post(apiUrl, {}).subscribe(
      (response: any) => {
        this.toasterService.pop(
          "success",
          "Success",
          "Proforma Invoice converted successfully!"
        );

        this.router.navigate([
          `/admin/invoice/add-view-invoice/${invoice.propertyId}`,
        ]);
      },
      (error) => {
        this.toasterService.pop("error", "Error", "Failed to convert invoice");
      }
    );
  }

  openCommonPayment(invoice: any) {
    console.log("Markpayment-invoice", invoice);
    console.log("Markpayment-recepintList", this.recepintList);
    const dialogRef = this.MatDialog.open(CommonPaymentComponent, {
      data: {
        invoice: invoice,
        recepintList: this.recepintList,
      },
    });

    dialogRef.afterOpened().subscribe(() => {
      const overlay = document.querySelector(".cdk-overlay-backdrop");

      if (overlay) {
        overlay.addEventListener("click", () => {
          dialogRef.close(); // Close the dialog when overlay is clicked
        });
      }
    });

    dialogRef.afterClosed().subscribe((res) => {
      this._CommonService.showLoading();
      this.getPropertyInvoice();
    });
  }

  deleteInvoice(invoice: any) {
    Swal.fire({
      icon: "error",
      title: "Delete Confirmation!",
      html: "Are you sure you want to delete this Invoice detail ?.",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      this._CommonService.showLoading();
      if (result.isConfirmed) {
        this._CommonService
          .delete(
            urlConstant.ProformaInvoice.deleteProformaInvoiceById,
            invoice.id
          )
          .subscribe((res: any) => {
            if (res.Status === "200") {
              this.toasterService.pop("success", "Success", res.message);
              this.getPropertyInvoice();
            }
          });
      } else {
        this._CommonService.hideLoading();
      }
    });
  }

  viewInvoiceInfo(invoice: any) {
    this.router.navigate([
      `admin/invoice-performa/performa-invoice/${this.propertyId}_rec_${invoice.id}_view`,
    ]);
  }

  getPropertyInvoice() {
    this._CommonService
      .get<any>(
        urlConstant.ProformaInvoice.getProformaInvoiceByPropertyId +
          "?propertyId=" +
          this.propertyId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          console.log("res", res);
          this.invoiceList = res.data.ProformaInvoice;
          console.log('tnis is invoce',this.invoiceList);
          this.invoiceTotalNumber = res.data.ProformaInvoiceTotalNumber;
          this.invoiceTotalPayment = res.data.ProformaInvoiceTotalPayment;
          this.assignToChartValue();
        } else if (res.Status === "409") {
          this.toasterService.pop("success", "Success", res.message);
          this._CommonService.hideLoading();
        } else {
          this.toasterService.pop("error", "Error", res.message);
          this._CommonService.hideLoading();
        }
      });
  }

  assignToChartValue() {
    this.totalInvoices = this.invoiceTotalNumber.totalProformaInvoices;
    this.totalPaidInvoices = this.invoiceTotalNumber.totalPaidInvoice;
    this.totalPendingInvoices =
      this.invoiceTotalNumber.totalPendingProformaInvoices;

    if (
      this.invoiceTotalPayment !== null &&
      this.invoiceTotalPayment !== undefined
    ) {
      this.totalDueAmount =
        this.invoiceTotalPayment.totalAmountDue !== null
          ? this.invoiceTotalPayment.totalAmountDue.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })
          : 0.0;
      this.totalAmountPaid =
        this.invoiceTotalPayment.totalAmountPaid !== null
          ? this.invoiceTotalPayment.totalAmountPaid.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })
          : 0.0;
      this.remainingAmount =
        this.invoiceTotalPayment.remainingBalance !== null
          ? this.invoiceTotalPayment.remainingBalance.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })
          : 0.0;
    }

    this.doughnutChartAmountData = [
      Number(Number(this.invoiceTotalPayment.totalAmountPaid).toFixed(2)),
      Number(Number(this.invoiceTotalPayment.remainingBalance).toFixed(2)),
    ];
    this.doughnutChartInvoiceData = [
      this.totalPaidInvoices,
      this.totalPendingInvoices,
    ];
    this._CommonService.hideLoading();
  }

  showTempLigthBox() {
    const dialogRef = this.MatDialog.open(ImageShowModalComponent, {
      width: "800px",
      data: {
        attachment: this.modalInvoice.imageList,
        index: 0,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  upToTwoDecimal(value: any) {
    return Number(value).toFixed(2);
  }

  editInvoice(invoice) {
    this.router.navigate([
      `admin/invoice-performa/performa-invoice/${this.propertyId}_inv_${invoice.id}_edit`,
    ]);
  }

  previous() {
    this.router.navigate([`admin/invoice-performa/invoice-details`]);
  }

  getFormatNumber(number: any) {
    return new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 2,
    }).format(number);
  }

  formatIndianNumerationWithDecimals(number: number): string {
    // // Convert the number to a string
    // let numStr = number !== null ? String(number):"0";

    // // Check if the number has decimals
    // let decimalPart = '';
    // const decimalIndex = numStr.indexOf('.');
    // if (decimalIndex !== -1) {
    //     decimalPart = numStr.substring(decimalIndex);
    //     numStr = numStr.substring(0, decimalIndex);
    // }

    // // Determine the length of the number
    // const length = numStr.length;

    // // Check if comma(s) need to be inserted
    // let commaIndex = length % 3;
    // let formattedNumber = numStr.substring(0, commaIndex);
    // while (commaIndex < length) {
    //     if (formattedNumber.length > 0) {
    //         formattedNumber += ',';
    //     }
    //     formattedNumber += numStr.substring(commaIndex, commaIndex + 3);
    //     commaIndex += 3;
    // }

    // // Add back the decimal part if exists, limiting it to two decimal places
    // formattedNumber += decimalPart.length > 0 ? decimalPart.substring(0, 3) : '';

    return number !== null && number !== undefined
      ? number.toLocaleString("en-IN", { maximumFractionDigits: 2 })
      : "0";
  }
}
